import type { onboarding as enOnboarding } from "../en/onboarding";

export const onboarding: typeof enOnboarding = {
  steps: {
    draftQuoteLabel: "Crea la tua prima bozza di preventivo",
    draftQuoteDescription: "Scegli un'azienda B2B, aggiungi le righe e salva come bozza.",
    sendQuoteLabel: "Invia un preventivo a un acquirente",
    sendQuoteDescription:
      "L'acquirente riceve un link email firmato per visualizzare, accettare o rifiutare il preventivo.",
    acceptQuoteLabel: "Fai accettare un preventivo",
    acceptQuoteDescription:
      "Quando l'acquirente clicca su Accetta nell'email, registriamo l'orario esatto.",
    convertDraftOrderLabel: "Converti in un ordine bozza Shopify",
    convertDraftOrderDescription:
      "L'accettazione crea automaticamente un ordine bozza B2B con l'entità di acquisto corretta.",
    shopifyDraftsLinkLabel: "Bozze Shopify",
  },
  setupGuide: {
    allDoneHeading: "Tutto pronto 🎉",
    allDoneBody:
      "Hai completato tutti i passaggi di configurazione — ottimo lavoro. Quando vuoi, esplora le funzionalità avanzate come l'analisi degli ordini d'acquisto e le controfferte IA.",
    seeEverythingLink: "Scopri tutto quello che Quote Desk può fare →",
    heading: "Configura Quote Desk",
    stepsComplete: "{{completed}} di {{total}} passaggi completati",
    autoCompleteHint: "Ogni passaggio si completa automaticamente man mano che usi l'app. Sei nuovo qui?",
    seeHowItWorksLink: "Scopri come funziona",
    openLink: "Apri",
  },
};
